import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-none tw-flex-col tw-space-y-1 tw-text-sm md:tw-w-[140px]" }
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (navItem) => {
      return (_openBlock(), _createElementBlock("div", {
        key: navItem.id
      }, [
        _createElementVNode("div", {
          title: _ctx.disabledReason,
          class: _normalizeClass({
          'tw-cursor-not-allowed': _ctx.disabled
        })
        }, [
          _createVNode(_component_router_link, {
            to: {
            name:
              navItem.id === _ctx.activeNavId && !navItem?.routeName
                ? ''
                : (navItem?.routeName ?? navItem?.subNavItems?.[0]?.routeName),
            params: navItem?.params
          },
            class: _normalizeClass(["tw-block tw-cursor-pointer tw-px-2 tw-py-1 tw-text-xs dark:tw-text-white", {
            'tw-font-semibold': navItem.id === _ctx.activeNavId,
            'tw-pointer-events-none': _ctx.disabled,
            'tw-rounded tw-bg-slate-100 tw-ring-slate-100 dark:tw-bg-slate-900 dark:tw-ring-slate-900':
              navItem.id === _ctx.activeNavId && !navItem.subNavItems
          }]),
            title: _ctx.disabledReason,
            "data-testid": `navigation-${navItem.title}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(navItem.title), 1)
            ]),
            _: 2
          }, 1032, ["to", "class", "title", "data-testid"])
        ], 10, _hoisted_2),
        (!_ctx.hideSubNav && navItem.subNavItems && navItem.id === _ctx.activeNavId)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(navItem.subNavItems, (subNavItem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: subNavItem.id,
                class: "tw-ml-2 tw-border-l tw-py-1 tw-pl-3"
              }, [
                _createVNode(_component_router_link, {
                  to: { name: subNavItem.routeName, params: subNavItem?.params },
                  class: _normalizeClass(["tw-block tw-cursor-pointer tw-px-2 tw-py-1 tw-text-xs dark:tw-text-white", {
              'tw-rounded tw-bg-slate-100 tw-ring-slate-100 dark:tw-bg-slate-900 dark:tw-ring-slate-900':
                subNavItem.id === _ctx.activeSubNavId
            }]),
                  "data-testid": `sub-navigation-${subNavItem.title}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(subNavItem.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class", "data-testid"])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}